import React from 'react';
import Square from './components/Square';
import { createSquare } from './utilities';

export default {
  current : '1',
  'editor' : { },
  'default' : {blurb : "Good luck!"},
  1 : {
    blurb : (
      <div>
        <h2>Welcome to Fractile</h2>
        <p>Fractile is a matching game. Click on animals to make groups of 3. A group must have everything identical, or everything different.</p>
        <p>We{"'"}ll start you off easy! Just make a set of 3 elephants, all blue, all the same size, all facing left.</p>
        <div align = 'center'>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
        </div>
      </div>
    )
  },
  2 : {
    blurb : (
      <div>
        <h2>That was easy!</h2>
        <p>See? No sweat.</p>
        <p>Animals have a size, color, direction, and type. Each of those attributes must be the same for all 3 animals in the set, or all must be different.
        That means that this is a set:</p>
        <div align = 'center'>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
        </div>
        <p>But this isn{"'"}t:</p>
        <div align = 'center'>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : 1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
        </div>
        <p>Because two elephans are facing left, but only one is facing right.</p>
        <p>Try making a set of elephants which are different colors and facing in different directions.</p>
      </div>
    )
  },
  3: {
    blurb : (
      <div>
        <h2>Wow! You{"'"}re a pro!</h2>
        <p>If you make a mistake and try to make an invalid set, the animals will go to sleep and you can{"'"}t match them for a little while. Bigger Animals
        sleep longer than smaller animals.</p>
        <p>Try making a set with the red elephants on the top first to see a mistake, then match the blue bottom three to finish the level.</p>
      </div>
    )
  },
  4 : {
    blurb : (
      <div>
        <p>Whew! Glad you didn{"'"}t need to wait 6 turns for those animals to wake up!</p>
        <p>But there{"'"}s another option! You can earn alarm clocks that will wake up an animal immediately. Try using an alarm clock to wake the sleeping elephant
        so you can make a set.</p>
        <div align = 'center'>
          <svg viewBox={'0 0 100 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : 'white', direction : -1, animal : 'alarm'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
        </div>
      </div>
    )
  },
  5 : {
    blurb: (
      <div>
        <p>You{"'"}re doing awesome!</p>
        <p>Smaller animals will frequently hide behind bigger animals. Make a set with the bigger animals, and then a set with the smaller ones behind them.</p>
      </div>
    )
  },
  6 : {
    blurb :(
      <div>
        <p>No problem!</p>
        <p>As you progress, more animals will come onto the board.</p>
        <p>Make a set with 3 mice to clear this level.</p>
      </div>
    )
  },
  7 : {
    blurb : (
      <div>
        <p>Sometimes you{"'"}ll just get stuck and not be able to do anything. But there are tools that can help you! You{"'"}ve already tried out the alarm clock</p>
        <div align='center'>
          <svg viewBox={'0 0 100 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : 'white', direction : -1, animal : 'wand'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>The magic wand will turn one animal into another one.</p>
          <p>Use it to turn that cat into a dog so you can make a set.</p>
          <p>Click on the wand to select it, then click on the cat to target it. Finally, click on a dog to change the cat into one.</p>
        </div>
      </div>
    )
  },
  8 : {
    blurb : (
      <div>
        <p>See how useful that magic wand is? But there are more tools in your toolbox!</p>
        <div align='center'>
          <svg viewBox={'0 0 100 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : 'white', direction : -1, animal : 'mirror'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>The mirror will make an animal face in the same direction as another.</p>
          <p>Use it to make that misbehaving cow look to the left.</p>
          <p>Click on the mirror to select it, then click on the upside down cow to target it. Finally, click on a cow facing to the left to change it.</p>
        </div>
      </div>
    )
  },
  9 : {
    blurb : (
      <div>
        <p>The mirror really helps getting everybody facing the right way, but it won{"'"} help if the color is wrong. For that you need a brush.</p>
        <div align='center'>
          <svg viewBox={'0 0 100 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : 'white', direction : -1, animal : 'brush'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>The brush will paint an animal the same color as another.</p>
          <p>Blue bears? What use are those? Paint him brown!</p>
          <p>Click on the brush to select it, then click on the blue bear to target it. Finally, click on a brown bear to change it.</p>
        </div>
      </div>
    )
  },
  10 : {
    blurb : (
      <div>
        <p>By now you may be wondering how you get more tools, and you do it by creating stars. Stars come in 3 sizes, just like everything else.</p>
        <div align = 'center'>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,37.5)'>
              <Square
                width  = { 25 }
                height = { 25 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : 'white', direction : -1, animal : 'star'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,25)'>
              <Square
                width  = { 50 }
                height = { 50 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : 'white', direction : -1, animal : 'star'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : 'white', direction : -1, animal : 'star'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
        </div>
        <p><b>Small stars</b> are the easiest to make - if you add a small animal to a set, it hides behind a star.</p>
        <p><b>Medium stars</b> are made automatically - once you have 8 small stars, they re-arrange and combine into a medium sized star and score 100 points.</p>
        <p><b>Large stars</b> are also made auomatically - once you have 8 medium stars, they re-arrange and combine into a large star and score 1000 points.</p>
        <p>If you click on a medium star, it will pop and give you a random tool.</p>
        <p>If you click on a large star, it will pop and give you 12 random tools.</p>
        <p>Use that knowledge to collect create a big star and earn some tools to use on the later levels!</p>
      </div>
    )
  },
  11 : {
    blurb :(
      <div>
        <p>I think you{"'"}re getting it!</p>
        <p>Put together everything you{"'"}ve learned to make 5 sets with elephants in them.</p>
      </div>
    )
  },
  12 : {
    blurb :(
      <div>
        <p>Excellent work!</p>
        <p>Now let{"'"}s see you score 500 points in this level. Remember - the more similar the set is, the more points you score.</p>
      </div>
    )
  },
  13 : {
    blurb :(
      <div>
        <p>Awesome!</p>
        <p>Make 5 sets of only 3 small elephants to proceed.</p>
      </div>
    )
  },
  14 : {
    blurb :(
      <div>
        <p>Awesome!</p>
        <p>You{"'"}ve totally got the hang of it. So...what do you think? Please contact me and let me know! But until I add more levels, just enjoy a free play board
        with everything on it. Score as high as you can! Good luck!</p>
      </div>
    )
  },

  772 : { failed : <div>Level 2 failed</div>, blurb : <div>Welcome to level 2</div> },
  771 : {
    failed : (
      <div>You failed! Try again!</div>
    ),
    blurb : (
      <div>
        <h2>Welcome to Fractile</h2>
        <p>Fractile is a matching game. Click on animals to make groups of 3. A group must have everything identical...</p>
        <div align = 'center'>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#6baed6', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>All elephants, all blue, all facing right, all the same size</p>
          <p style = {{marginTop : '25px'}}>Or everything should be different:</p>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#FFAAAA', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(122.5,12.5)'>
              <Square
                width  = { 75 }
                height = { 75 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#AAFFAA', direction : 0, animal : 'rhino'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(245,25)'>
              <Square
                width  = { 50 }
                height = { 50 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#AAFFFF', direction : 1, animal : 'hippo'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>3 different animals, in 3 different directions, with 3 different colors, of three different sizes.</p>
          <p style = {{marginTop : '25px'}}>Each individual property (animal, direction, size, color) must be identical or different.</p>
          <svg viewBox={'0 0 320 100'}>
            <g transform='translate(0,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {0}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#FFAAAA', direction : -1, animal : 'elephant'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(110,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {1}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#AAFFAA', direction : -1, animal : 'rhino'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
            <g transform='translate(220,0)'>
              <Square
                width  = { 100 }
                height = { 100 }
                idx    = {2}
                square = { createSquare({square_id : -1, parent_id : 0, idx : 0, depth : 1, fill : '#AAFFFF', direction : -1, animal : 'hippo'}) }
                immortal = { true }
                autoPlace= { false }
              />
            </g>
          </svg>
          <p>3 different animals, 3 different colors, all the same size, all facing left.</p>
        </div>
      </div>
    ),
  },
};



// WEBPACK FOOTER //
// ./src/levels.js